export const DAYS_OF_WEEK_MAP = {
    'mon': 'Monday',
    'tue': 'Tuesday',
    'wed': 'Wednesday',
    'thu': 'Thursday',
    'fri': 'Friday',
    'sat': 'Saturday',
    'sun': 'Sunday'
  };

export const STYLED_TABLE_CONFIG = {
    width: "100%",
    borderRadius: "8px",
    borderCollapse: "separate"
};

export const STYLED_CELL_CONFIG = {
    align: "left",
    fontSize: "0.8rem",
    padding: "12px",
    color: '#171A1E'
};
    
export const STYLED_HEADER_CELL_CONFIG = {
    height: "10px",
    align: "left",
    color: "#000000",
    fontWeight: "bold",
    fontSize: "0.8rem",
    backgroundColor: '#ECEFF3',
    padding: "9px"
};

export const DEEP_LINKS_BASE_URL = "gbrappi://com.grability.rappi";

export const BANNERS_FILTER_METHODS_MAP = {
    'merchandising_restaurant': 'Restaurant Prioritization Group',
    'merchandising_cpgs': 'Shop Prioritization Group',
    'merchandising_misc': 'Multi-Vertical Prioritization Group',
  };

export const BANNERS_ACTION_TYPE_MAP = {
    'products': 'Products in-app',
    'stores': 'Stores in-app',
    'deeplink': 'Deeplink'
};

export const IDS_TYPE_MAP_BY_ACTION_TYPE = {
  'products': {
    'product_ids': 'Product Ids',
    'store_types_products_ids': 'Store Types Product Ids'
  },
  'stores': {
    'store_ids': 'Store Ids',
    'brand_ids': 'Brand Ids',
    'store_type_ids': 'Store Type Ids'
  },
  'deeplink': {}
};

export const CAROUSELS_ACTION_TYPE_MAP = {
  'product_ids': 'Products',
  'brand_ids': 'Restaurants',
  'cpgs_ids': 'Shops - CPGs'
};

export const IDS_TYPE_MAP_BY_CAROUSEL_ACTION_TYPE = { // TODO: delete and replace with IDS_TYPE_MAP_BY_ACTION_TYPE when store_types_products_ids is available for carousels
  'product_ids': {
    'store_types_products_ids': 'Store Types Product Ids',
    'product_ids': 'Product Ids',
  },
  'brand_ids': {
    'brand_ids': 'Brand Ids',
  },
  'cpgs_ids': {
    'store_type_ids': 'Store Type Ids'
  }
};

export const IDS_TYPE_MAP_BY_FILTER_METHOD = {
  'product_ids': 'Product Ids',
  'brand_ids': 'Brand Ids',
  'cpgs_ids': 'Store Type Ids'
};

export const PLATFORMS_MAP = {
  'Android': 'Android',
  'iOS': 'iOS',
  'ALL': 'All'
};

export const PRODUCT_IDS_TYPE_MAP = {
    'restaurant_products': 'Restaurant Products',
    'cpgs_products': 'CPGs Products'
};

export const CAROUSELS_INDEX_START_FROM = 10;